import { initialiseStores } from '~/utils/store-accessor'

export default (context: any) => {
  initialiseStores(context.store)
}
